// register component(s) with react habitat

import PostsSlider from './slider'

export default {
  PostsSlider,
}
